import React from 'react';
import { BarChart, Trash2, Layers } from 'lucide-react';
import { formatCurrency, formatNumber } from '../../../../../utils/formatting';
import Button from '../../../../../components/ui/Button';

/**
 * Компонент боковой панели для сравнения сохраненных кредитов
 */
const ComparisonSidebar = ({ 
  savedLoans, 
  deleteSavedLoan, 
  loadSavedLoan 
}) => {
  // Если нет сохраненных кредитов
  if (!savedLoans || savedLoans.length === 0) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
          <BarChart className="w-5 h-5 mr-2 text-indigo-500" />
          Сравнение кредитов
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Здесь будут отображаться сохраненные варианты кредитов для сравнения.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white flex items-center">
          <BarChart className="w-5 h-5 mr-2 text-indigo-500" />
          Сравнение кредитов
        </h3>
        <span className="text-sm text-gray-500 dark:text-gray-400">
          {savedLoans.length} {savedLoans.length === 1 ? 'вариант' : savedLoans.length < 5 ? 'варианта' : 'вариантов'}
        </span>
      </div>

      <div className="space-y-4">
        {savedLoans.map((loan) => (
          <div 
            key={loan.id} 
            className="bg-gray-50 dark:bg-gray-700/30 border border-gray-200 dark:border-gray-700 rounded-lg p-4 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors group"
          >
            <div className="flex justify-between items-start mb-2">
              <h4 className="text-sm font-medium text-gray-900 dark:text-white">
                {loan.name}
              </h4>
              <div className="flex items-center space-x-2">
                <Button
                  size="sm"
                  variant="ghost"
                  icon={<Layers className="w-4 h-4" />}
                  onClick={() => loadSavedLoan(loan.id)}
                  title="Загрузить параметры"
                />
                <Button
                  size="sm"
                  variant="ghost"
                  icon={<Trash2 className="w-4 h-4 text-red-500" />}
                  onClick={() => deleteSavedLoan(loan.id)}
                  title="Удалить"
                />
              </div>
            </div>
            <div className="text-sm text-gray-600 dark:text-gray-400">
              <div className="flex justify-between mb-1">
                <span>Сумма:</span>
                <span className="font-medium">
                  {formatCurrency(loan.formData.loanAmount, 0)}
                </span>
              </div>
              <div className="flex justify-between mb-1">
                <span>Срок:</span>
                <span>
                  {loan.formData.loanTerm} {pluralize(parseFloat(loan.formData.loanTerm), 'год', 'года', 'лет')}
                </span>
              </div>
              <div className="flex justify-between mb-1">
                <span>Ставка:</span>
                <span>
                  {formatNumber(loan.formData.interestRate, 2)}%
                </span>
              </div>
              <div className="flex justify-between">
                <span>Ежемесячный платеж:</span>
                <span className="font-semibold text-indigo-600 dark:text-indigo-400">
                  {formatCurrency(loan.results.averageMonthlyPayment, 0)}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Вспомогательная функция для склонения слов
const pluralize = (number, one, few, many) => {
  let n = Math.abs(number);
  n %= 100;
  if (n >= 5 && n <= 20) {
    return many;
  }
  n %= 10;
  if (n === 1) {
    return one;
  }
  if (n >= 2 && n <= 4) {
    return few;
  }
  return many;
};

export default ComparisonSidebar;